import { FC, PropsWithChildren } from "react";
import styles from "./Table.module.scss";
import { getScreenSize } from "@utils/getScreenSize";

const TableItems: FC<PropsWithChildren> = ({ children }) => {
    const { isMobile } = getScreenSize();
    return (
        <div className={styles.tableHolder}>
            {!isMobile ? (
                <table className={styles.table}>
                    <thead>
                        <tr>
                            <th>Time</th>
                            <th>Transaction type</th>
                            <th>Wallet</th>
                            <th>Amount</th>
                            <th className={styles.statusHolder}></th>
                        </tr>
                    </thead>
                    <tbody>{children}</tbody>
                </table>
            ) : (
                <>{children}</>
            )}
        </div>
    );
};

export default TableItems;
